import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface QuickApplyConnectResponse extends BackendResponse {
  item: string;
}

export interface QuickApplyConnectParameters extends NextApiParams {
  /**
   * concernId: number;
   * relatedId: number;
   * relatedType: number;
   * applicationText: string;
   * redirectUrl: string;
   * consent: boolean;
   * files: any[] | null;
   * firstName: string;
   * lastName: string;
   */
  formData: FormData;
}

export const quickApplyConnect = withNextApi<
  QuickApplyConnectResponse,
  QuickApplyConnectParameters
>("Auth/QuickApplyConnect");
